export default __webpack_public_path__ + "images/cce8f7367410541fd1d97868527dcbca.svg";